import apiClient from './client'

export const announcementServices = {
  getAll: () => apiClient.get('/announcements'),
}
